// src/universal/hooks/useSAudioPlayer/utils/actions.ts
var playAudio = (player) => {
  if (player.paused) {
    player.play();
    return "play";
  }
  player.pause();
  return "pause";
};
var muteAudio = (player) => {
  if (player.muted) {
    player.muted = false;
    return "unmute";
  }
  player.muted = true;
  return "mute";
};
var loopAudio = (player) => {
  if (player.loop) {
    player.loop = false;
    return "unloop";
  }
  player.loop = true;
  return "loop";
};
var seek = (player, position) => {
  player.currentTime = position;
};

export { loopAudio, muteAudio, playAudio, seek };
//# sourceMappingURL=chunk-YHTQVMXH.mjs.map
//# sourceMappingURL=chunk-YHTQVMXH.mjs.map